/*
##############
## CheckBox ##
##############
Input type check box custom.

* OPTIONS
    * checkBoxList[Array]: List of options. Required
    * model[String]: Model of data. Required.
    * Label: Show input name. Not required.
    * fieldsRequired: Fields required to complete process. Not Required.

* EXAMPLE
    <CheckBox
        checkBoxList={[{
            label: 'España',
            model: 'userProfile.selfEmployed_spain',
            onChange: function(e) {
                console.log(e); // return true or false
            }
        },{
            label: 'Extranjero',
            model: 'userProfile.selfEmployed_foreign',
            required: false
        }]}
        fieldsRequired="1"
        {...this.props}
    />

*/

const React = require('react');
const PropTypes = require('prop-types');
const { Errors } = require('react-redux-form');
import { formatText } from 'core/i18n';

const { recordError } = require('utilities/uTagging');
const scroll = require('utilities/scroll');

class checkBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            trigger: false,
            classFocus: '',
        };

        this.handleOnChange = this.handleOnChange.bind(this);
        this.buildCheckBox = this.buildCheckBox.bind(this);
        this.changeClassError = this.changeClassError.bind(this);
        this.renderErrors = this.renderErrors.bind(this);
        this.onFocusAnimate = this.onFocusAnimate.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);

        this.divisaderoError = '';
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { userProfileForm, profileModel } = nextProps;

        const modelProp = profileModel.split('.')[1];

        if (userProfileForm && userProfileForm && userProfileForm[modelProp]) {
            this.changeClassError(!userProfileForm[modelProp].valid);
        }
    }

    componentDidMount() {
        const { userProfile, profileModel, formActions, checkBoxList } = this.props;
        const modelProp = profileModel.split('.')[1];
        userProfile[modelProp] === undefined && formActions.change(profileModel, false);

        checkBoxList.forEach(checkBox => {
            const checkBoxModelProp = checkBox.model.split('.')[1];
            userProfile[checkBoxModelProp] === undefined && formActions.change(checkBox.model, false);
        });
    }

    componentDidUpdate() {
        if (this.state.trigger) {
            const { profileModel, userProfileForm, userProfile, noTag } = this.props;
            let modelProp;
            if (typeof profileModel !== 'undefined') {
                modelProp = profileModel.split('.')[1];
            }
            if (
                userProfileForm &&
                userProfileForm &&
                userProfileForm[modelProp] &&
                !userProfileForm[modelProp].valid &&
                !noTag
            ) {
                recordError(
                    `${modelProp} : ${this.divisaderoError}`,
                    userProfile.investmentType ? userProfile.investmentType : ''
                );
            }

            this.changeTrigger(false);
        }
    }

    changeTrigger(trigger) {
        this.setState({
            trigger,
        });
    }

    changeClassError(change) {
        const classError = change ? 'form__input--error valid-error' : '';
        this.setState({
            classError,
        });
    }

    handleOnChange(event, propModelName, ch) {
        const { userProfile, profileModel, formActions, fieldsRequired, checkBoxList, onChange } = this.props;
        const model = event.target != null ? event.target.name : '';
        const isInputChecked = !userProfile[propModelName];

        formActions.change(model, isInputChecked);
        if (ch != null) {
            ch(isInputChecked);
        }

        if (fieldsRequired != null) {
            const checkedBoxes = checkBoxList.filter(checkBox => {
                const modelProp = checkBox.model.split('.')[1];
                const selectedCheckboxModel = model.split('.')[1];

                return modelProp === selectedCheckboxModel ? isInputChecked : userProfile[modelProp];
            });
            const areNecessaryBoxesChecked = checkedBoxes.length >= fieldsRequired;

            formActions.change(profileModel, areNecessaryBoxesChecked);
            formActions.setValidity(profileModel, { required: areNecessaryBoxesChecked });
            checkBoxList.forEach(checkBox =>
                formActions.setValidity(checkBox.model, { required: areNecessaryBoxesChecked })
            );
        }

        if (onChange) onChange(isInputChecked);
        this.changeTrigger(true);
    }

    handleOnFocus() {
        const { focusAnimated } = this.props;
        if (focusAnimated) {
            this.onFocusAnimate();
        }
    }

    onFocusAnimate() {
        const { profileModel } = this.props;
        const modelProp = profileModel.split('.')[1];
        const element = document.getElementById(`id_wrapper_${modelProp}`);
        if (element) {
            scroll.transition(element);
        }
    }

    generateKey(pre) {
        return `${pre}_${new Date().getTime()}`;
    }

    buildCheckBox(model, label, onChange, remarkable, errorMessageComponent) {
        const {
            userProfileForm,
            userProfile,
            disabled,
            listClassName,
            description,
            boldLabel,
            messagesError,
            checkBoxListErrorMessage,
        } = this.props;
        const handleOnChange = this.handleOnChange;
        let propName = '';
        if (typeof model !== 'undefined') {
            propName = model.split('.')[1];
        }

        const id = this.generateKey(propName);
        let ch;
        if (onChange != null) {
            ch = onChange;
        }
        let checked = userProfile[propName];
        if (typeof checked === 'undefined' || checked === null) {
            checked = false;
        }
        const classRemarkable = remarkable ? 'form__check-remarkable' : '';
        const classCheck = checked
            ? `form__check form__check--checked ${classRemarkable}`
            : `form__check ${classRemarkable}`;

        const isValueValid = userProfileForm && userProfileForm[propName]?.valid;
        const shouldAddErrorClass = userProfileForm !== undefined && !isValueValid;

        const checkClassWithError = `${classCheck} ${shouldAddErrorClass ? 'error-class-check' : ''}`;
        const errorComponent = errorMessageComponent || (
            <Errors model={model} messages={messagesError} component={this.renderErrors} />
        );
        return (
            <li key={id} className={listClassName}>
                <input
                    className={checkClassWithError}
                    type="checkbox"
                    name={model}
                    id={id}
                    onChange={function (event) {
                        handleOnChange(event, propName, ch);
                    }}
                    checked={checked}
                    disabled={disabled}
                    onFocus={this.handleOnFocus}
                />
                <label className="sub-label" htmlFor={id}>
                    {boldLabel ? <b>{label}</b> : label}
                    {description && (
                        <React.Fragment>
                            <br /> {description}
                        </React.Fragment>
                    )}
                </label>
                {!isValueValid && (checkBoxListErrorMessage ? <></> : errorComponent)}
            </li>
        );
    }

    renderErrors(props) {
        this.divisaderoError = props.children;
        return <p className={this.props.errorStyle}>{props.children}</p>;
    }

    render() {
        const { style, profileModel, checkBoxList, remarkable, checkBoxListErrorMessage } = this.props;
        const className = `form__check-list ${this.state.classError}`;
        const buildCheckBox = this.buildCheckBox;
        const checkViews = [];
        const modelProp = profileModel.split('.')[1];
        if (checkBoxList != null) {
            checkBoxList.map((checkBox, i) => {
                checkViews[i] = buildCheckBox(
                    checkBox.model,
                    checkBox.label,
                    checkBox.onChange,
                    remarkable,
                    checkBox.errorMessageComponent
                );
            });
        }
        return (
            <div style={style} id={`id_wrapper_${this.generateKey(modelProp)}`}>
                <ul className={className}>{checkViews}</ul>
                <Errors
                    model={profileModel}
                    messages={{ required: checkBoxListErrorMessage }}
                    component={this.renderErrors}
                />
            </div>
        );
    }
}

checkBox.propTypes = {
    profileModel: PropTypes.string,
    fieldsRequired: PropTypes.string,
    checkBoxList: PropTypes.array,
    userProfile: PropTypes.object,
    errorStyle: PropTypes.string,
    userProfileForm: PropTypes.object,
    formActions: PropTypes.object,
    style: PropTypes.object,
    remarkable: PropTypes.bool,
    description: PropTypes.string,
    boldLabel: PropTypes.bool,
    checkBoxListErrorMessage: PropTypes.string,
    noTag: PropTypes.bool,
};

checkBox.defaultProps = {
    messagesError: { required: formatText('validation-fieldRequired') },
    disabled: false,
    style: {},
    remarkable: false,
    errorStyle: 'form__field_error',
    focusAnimated: false,
    description: '',
    boldLabel: false,
    noTag: false,
};
module.exports = checkBox;
